/*
 * @Author: ’‘
 * @Date: 2022-04-14 10:26:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-27 14:42:17
 * @FilePath: /activity_cfhd_a20220921netbar/utils.ts
 * @Description:
 */
// 复制功能
// import { initPage, initFunction } from './diyWork/init'
declare function need(path: string | Array<string>, cb: Function): any
declare function g(id: string): any
declare function amsSubmit(actid: number, flowId: number): any

import milo from '@tencent/milo-web'
import { plat, isPage } from './diyWork/config'

declare namespace InitShare {
  interface pcQrcodeCfg {
    width: number
    height: number
    class: string
  }
  interface classList {
    pcBtnClass?: string
    h5BtnClass?: string
    zoneBtnClass?: string
    copyBtnClass?: string
    inputValClass: string
  }
}
declare namespace window {
  var cfhdCallbackObj: any
  var WxjssdkWx: any
  namespace location {
    var href: string
    var search: any
  }
  function open(s: string, b: string)
}

declare var GameHelper, LoginManager

function copyText(text: string, callback?: () => any): any {
  var tag = document.createElement('input')
  tag.setAttribute('id', 'cp_hgz_input')
  tag.value = text
  document.getElementsByTagName('body')[0].appendChild(tag)
  ;(document.getElementById('cp_hgz_input') as any).select()
  document.execCommand('copy')
  document.getElementById('cp_hgz_input').remove()
  if (typeof callback == 'function') {
    callback()
  }
}

function getUrlParam(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function zalert(msg: string, confirmCallback: Function) {
  need('util.modalDialog', function (Dialog: any) {
    Dialog.alert(msg, {
      onConfirm: confirmCallback
    })
  })
}
// 是否是手Q内打开
function isQQ(): boolean {
  return / qq\//i.test(navigator.userAgent)
}
// 是否是手Q内打开
function isWX(): boolean {
  return /MicroMessenger/gi.test(navigator.userAgent)
}
function initShareFunc(pcUrl: string, h5Url: string, title: string, desc: string, summary: string, iconPic: string, pcQrcodeCfg: InitShare.pcQrcodeCfg, h5popId: string) {
  let sharePCUrl: string = pcUrl || window.location.href
  let shareMobileUrl: string = h5Url || window.location.href

  // 如果在wx和QQ的环境内，应该直接执行sth
  if (isWX() || isQQ()) sth(shareMobileUrl, '', title, desc, iconPic)

  let shareH5 = function () {
    sth(shareMobileUrl, h5popId, title, desc, iconPic)
  }
  let shareZone = function () {
    milo.pcShare.qzoneShare.share({
      url: sharePCUrl, //分享链接[可选，不传则取页面url]
      title: title, //分享标题[可选，不传则取页面title]
      desc: desc, //分享描述[可选，不传则为空]
      pics: iconPic, //分享图片[可选，不传表示不带图片]
      summary: summary, //分享摘要[可选，不传取页面title]
      site: '来源网站', //分享来源[可选，不传则为空]
      md: 1, //1默认不允许更改  0允许更改
      callback: function (shareId) {
        //回调函数，分享成功之后执行的函数
        // alert("分享成功了,分享Id为"+shareId);
        console.log('Success Share!shareId is' + shareId)
      }
    })
    closeDialog()
  }
  var shareQQ = function () {
    var p = {
      url: shareMobileUrl,
      /*获取URL，可加上来自分享到QQ标识，方便统计*/
      desc: desc,
      /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/
      title: title,
      /*分享标题(可选)*/
      summary: summary,
      pics: iconPic,
      /*分享图片(可选)*/
      flash: '',
      site: '',
      style: '201',
      width: 32,
      height: 32
    }
    var s = []
    for (var i in p) {
      s.push(i + '=' + encodeURIComponent(p[i] || ''))
    }
    window.open('//connect.qq.com/widget/shareqq/index.html?' + s.join('&'), '')
  }
  if (pcQrcodeCfg != undefined && isPage != 'H5') {
    // 二维码
    milo.loader
      .loadScript('//cfhd.cf.qq.com/cp/a20210817cfhdrlr/js/jquery.qrcode.min.js')
      .then((res) => {
        $(pcQrcodeCfg.class).empty()
        jQuery(function () {
          ;($(pcQrcodeCfg.class) as any).qrcode({
            width: pcQrcodeCfg.width,
            height: pcQrcodeCfg.height,
            text: shareMobileUrl
          })
        })
      })
      .catch((e) => console.log(e))
  }
  return {
    shareZone: shareZone,
    shareH5: shareH5,
    shareQQ: shareQQ
  }
}
function sth(url: string, popId: string, title: string, desc: string, iconPic: string) {
  var curHtmlUrl = window.location.href
  if (new RegExp('cfapp').test(navigator.userAgent) || /GameHelper/.test(navigator.userAgent) || /cfapp/.test(navigator.userAgent)) {
    launchShareWindow(url, title, desc, iconPic)
    //}else if((curHtmlUrl.indexOf("djc") >= 0 || curHtmlUrl.indexOf("props") >= 0 || curHtmlUrl.indexOf("act") >= 0 || curHtmlUrl.indexOf("daojucheng") >= 0 || curHtmlUrl.indexOf("daoju") >= 0)&&curHtmlUrl.indexOf("sEncrypt") == -1){
  } else if (isWX() || isQQ()) {
    const opts = {
      wx_appid: 'wx4a6848ac08e18340', //微信公众号appid
      title, // 分享标题，默认为活动页面标题（可手动调整）
      desc, //分享活动简介
      link: url, //分享链接
      imgUrl: iconPic, //分享后朋友看到的图标
      /*微信分享回调【不需要可不写】*/
      WXtrigger: function (res) {
        //微信点击事件回调
        //  alert("微信点击回调\n"+JSON.stringify(res));
      },
      WXsuccess: function (res) {
        //微信分享成功回调
        alert('分享成功！')
        // alert("微信分享成功回调\n"+JSON.stringify(res));
      },
      WXcancel: function (res) {
        //微信分享取消回调
        // alert("微信分享取消回调\n"+JSON.stringify(res));
      },
      WXfail: function (res) {
        //微信分享失败回调
        // alert("微信分享失败回调\n"+JSON.stringify(res));
      },

      QQcallback: function (res) {
        //qq成功、失败、或取消的回调
        // alert("QQ分享之后回调回调\n"+JSON.stringify(res));
      },
      QQtrigger: function (res) {
        //qq触发事件的回调
        // alert("QQ分享触发回调\n"+JSON.stringify(res));
      },

      qqBrowserCallback: function (data) {
        //data.code ==1 表示能分享
        //data.code ==-1 表示不能分享
        //data.code == 0 表示未知
        // alert("QQ浏览器分享触发回调\n"+JSON.stringify(data));
      }
    }
    milo.mobileShare.initShareAll(opts) // 页面初始化时调用
    TGDialogS(popId)
  } else if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    // 手机H5端 暂时不做处理
    alert('为了您的活动体验，请前往手机QQ或者微信参加~')
  }
}

function launchShareWindow(url, title, desc, iconPic) {
  var title = title,
    desc = desc,
    icon = iconPic
  if (typeof GameHelper != 'undefined') {
    GameHelper.shareWebPageWithFuntion(title, desc, icon, url, '1,2,3,4,5', 1)
  } else {
    //zhtc();

    var comment_info = desc
    var share_url = url
    var title = title
    var summary = desc
    var icon = iconPic
    var collect_state = 1

    //掌上cf分享ios需要的函数
    var sendIosMessage = function (src) {
      var oIFrame: any = document.getElementById('__MessageIframe__')
      if (!oIFrame) {
        oIFrame = document.createElement('iframe')
        oIFrame.id = '__MessageIframe__'
        oIFrame.frameborder = '0'
        oIFrame.scrolling = 'no'
        oIFrame.width = '0px'
        oIFrame.height = '0px'
        oIFrame.frameBorder = '0'
        oIFrame.style.display = 'none'
        oIFrame.src = src
        document.body.appendChild(oIFrame)
      } else {
        oIFrame.src = src
      }
    }

    //掌上cf分享安卓需要的函数
    var sendAndroidMessage = function (src) {
      window.location.href = src
    }

    var data = {
      title: encodeURIComponent(title),
      summary: encodeURIComponent(summary),
      icon: encodeURIComponent(icon),
      is_act: encodeURIComponent('1'),
      url: encodeURIComponent(share_url),
      collect_state: encodeURIComponent(collect_state)
      //"shareopen" : encodeURIComponent("1")
    }
    var src = 'requestapp://sharenew?param=' + encodeURIComponent(JSON.stringify(data))
    if (new RegExp('cfapp').test(navigator.userAgent)) {
      if (new RegExp('Android').test(navigator.userAgent)) {
        sendAndroidMessage(src)
      } else {
        sendIosMessage(src)
      }
    }
  }
}

function handleGiftCount(list) {
  list.map(function (ele) {
    // console.log(ele.sPackageName)
    // console.log(!ele.sPackageName.search(/\*[0-9]/))
    if (parseInt(ele.iPackageNum) > 1 && ele.sPackageName.search(/\*/) < 0) {
      ele.sPackageName += '*' + ele.iPackageNum
    }
  })
  return list
}

export function giftRecord(ActId: number, giftId: number) {
  const tmp = `<div class="milo-dialog" id="myGiftlist_dialog_${giftId}" style="display:none">
                  <div class="milo-dialog-mask"></div>
                  <div class="milo-dialog-content">
                      <div class="milo-mygiftlist-dialog">
                          <div class="milo-mygiftlist-dialog-header">
                              <div>信息提示</div>
                              <i class="milo-mygiftlist-close-btn" id="myGiftlist_dialog_close_${giftId}"></i>
                          </div>
                          <div class="milo-mygiftlist-dialog-content">
                              <div class="tips"><strong>温馨提示</strong>：虚拟道具奖品将在24小时内发到您的游戏内仓库，请耐心等候，谢谢您的理解与支持！</div>
                              <table>
                                  <thead>
                                      <tr>
                                          <th style="width:33%">获奖时间</th>
                        
                                          <th style="width:34%">所获礼包</th>
                                          <th style="width:33%">礼包数量</th>
                                          
                                      </tr>
                                  </thead>
                                  <tbody id="myGiftlist_tbody_${giftId}">
                      
                                  </tbody>
                                  <tfoot id="myGiftlist_footer_${giftId}" class="pagination">
                      
                                  </tfoot>
                              </table>
                          </div>
                      </div>          
                  </div>
                </div>`
  const style = `
  <style>
  .milo-mygiftlist-dialog {
    width: 600px;
    background-color: #fff;
    z-index: 1000;
 }
 
 .milo-mygiftlist-dialog  .milo-mygiftlist-dialog-header {
    width: 100%;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) repeat-x 0 -97px;
    height: 36px;
    line-height: 36px;
    margin: 0px;
    color: #fff;
    padding: 0 20px;
    position: relative;
    box-sizing: border-box;
 }
 
 .milo-mygiftlist-dialog  .milo-mygiftlist-dialog-header .milo-mygiftlist-close-btn {
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px 10px 0 0;
    width: 14px;
    height: 13px;
    text-indent: -999em;
    overflow: hidden;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) no-repeat -297px -5px;
 }
 
 .milo-mygiftlist-dialog-content {
    padding: 20px;
 }
 .milo-mygiftlist-dialog-content table {
    width: 100%;
    border-collapse:collapse;
 }
 
 .milo-mygiftlist-dialog-content .tips {
    font-size: 12px;
 }
 .milo-mygiftlist-dialog-content table th{
    border: 1px solid #e8e8e8;
    padding: 4px 2px;
    width: 33.3%;
    text-align: center;
    font-weight: normal;
    background: #efefef;
 }
 .milo-mygiftlist-dialog-content table td {
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #fff;
    color: #000;
    border: 1px solid #e8e8e8;
 }
 .milo-mygiftlist-dialog-content .pagination {
      background: #efefef;
      text-align: center
 }
 .milo-mygiftlist-dialog-content .pagination .page {
     border:none;
 }
 
 .milo-mygiftlist-dialog-mobile {
    width: 300px;
    max-height: 600px;
    overflow: scroll;
    background-color: #fff;
    z-index: 1000;
 }
 .milo-mygiftlist-dialog-mobile  .milo-mygiftlist-dialog-header {
    width: 100%;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) repeat-x 0 -97px;
    height: 30px;
    line-height: 30px;
    margin: 0px;
    color: #fff;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;
 }
 .milo-mygiftlist-dialog-mobile  .milo-mygiftlist-dialog-header .milo-mygiftlist-close-btn {
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px 10px 0 0;
    width: 14px;
    height: 13px;
    text-indent: -999em;
    overflow: hidden;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) no-repeat -297px -5px;
 }
 .milo-mygiftlist-dialog-mobile .milo-mygiftlist-dialog-content {
    padding: 10px;
 }
 .milo-mygiftlist-dialog-mobile .milo-mygiftlist-dialog-content table {
    width: 100%;
    font-size: 14px;
    border-collapse:collapse;
 }
 </style>`
  $('body').after(style)
  $('script:last').after(tmp)

  milo.MyGiftList.init({
    plat: plat,
    iActivityId: ActId,
    iFlowId: giftId,
    flowConfig: {
      everyUpdate: true,
      pageSize: '10',
      pageNow: 1
    },
    tableBodyRender: (list) => {
      const getStatus = (giftInfo) => {
        if (giftInfo.iStatus == '0') {
          return '成功'
        }
        if (!giftInfo.itemList) {
          return '发货中'
        } else {
          return giftInfo.itemList
            .map((item) => {
              if (item.iItemStatus == '0') {
                return `<span style="color:green;">${item.sItemName}(${item.iItemNum}) 已发货 </span><br>`
              } else {
                return `<span style="color:#aaa;">${item.sItemName}(${item.iItemNum}) 发货中 </span><br> `
              }
            })
            .join('')
        }
      }
      if (list && list.length) {
        return list
          .map((giftInfo) => {
            return `
                          <tr>
                              <td>${giftInfo.getTime}</td>
                              <td>${giftInfo.packageName}</td>
                              <td>${giftInfo.iPackageNum}</td>
                        <!-- <td>${getStatus(giftInfo)}</td>-->
                          </tr>
                      `
          })
          .join('')
      } else {
        return `
                    <tr>
                        <td colspan="4" align="center">您尚未获得任何礼包</td>
                    </tr>
                  `
      }
    }
    // tableFooterRender:tableFooterRender,
  }).then((mygiftlist) => {
    mygiftlist.showDialog()
  })
}

// function realGoodGift(iPageType, iActivityId, flowId, domStr) {
//   var amsCfg = 'amsCfg_' + flowId
//   if (iPageType == 'H5') {
//     var h5Template =
//       '<style>.donsonClass{background: #fff !important; top: 35% !important; left: 40% !important ;width: 54% !important;font-size: 18px;height:700px !important; padding-left: 40px !important;padding-top: 40px !important;}</style>' +
//       '<style type="text/css">.defaultContent{display: block;	width: 300px;z-index: 4201;top: 50%;left: 50%;position: fixed;margin-left: -150px;margin-top: -221.5px;background-color: #fff;	text-align: center;	-moz-border-radius: 8px;-webkit-border-radius: 8px;	border-radius: 8px;	box-shadow: rgb(178, 178, 178) 0px -1px 1px -1px inset;	}.defaultContent form{padding: 20px;}.defaultContent .star{color: #f00;}' +
//       '.defaultContent .submitBtn{display:block;width: 120px;height: 40px;background: url(http://ossweb-img.qq.com/images/cf/act/a20100610wcg/pIsubmitBtn.jpg) no-repeat 0px 0px;margin: 20px auto 0px auto;}.defaultContent table td{text-align: left;}</style>' +
//       '<!-- 填写个人信息 html --><div id="personInfoContent_' +
//       flowId +
//       '" class="defaultContent donsonClass" style="display:none;">' +
//       '<form id="form_personInfo_' +
//       flowId +
//       '" name="form_personInfo_' +
//       flowId +
//       '"><header><a href="###" id="colseLayer_' +
//       flowId +
//       '" style="float: right;">关闭</a></header>' +
//       '<section style="clear: both;"><table class="lz_act_pop_table"><tbody><tr style="display:none;" id="tr_package_name_' +
//       flowId +
//       '"><td><span class="star">*</span> 所获实物：</td></tr>' +
//       '<tr style="display:none;" id="tr_package_value_' +
//       flowId +
//       '"><td><select name="sPackageInfo" id="package_' +
//       flowId +
//       '"></select></td></tr>' +
//       '<tr><td><span class="star">* </span>姓名：</td></tr><tr><td><input name="sName" type="text" /></td></tr>' +
//       // <tr>
//       // 	<td>
//       // 		<span class="star"> </span>性别：
//       // 	</td>
//       // </tr>
//       // <tr>
//       // 	<td>
//       // 		<label for="sMale"><input type="radio" checked="checked" style="width: 14px;" value="male" id="sMale" name="sGender" />男</label>
//       // 		<label for="sFemale" ><input type="radio" value="female" style="width: 14px;" id="sFemale"  name="sGender"  />女</label>
//       // 	</td>
//       // </tr>

//       '<tr><td><span class="star">* </span>身份证号码：</td></tr><tr><td><input name="sIdentity" type="text" /></td></tr>' +
//       '<tr><td><span class="star">* </span>手机号码：</td></tr><tr><td><input name="sMobile" type="text" /></td></tr>' +
//       '<tr><td><span class="star">* </span>所在城市：</td></tr><tr><td><select name="sProvince" id="province_' +
//       flowId +
//       '"  style="width:100px;"></select><select name="sCity" id="city_' +
//       flowId +
//       '"  style="width:100px;"></select><select name="sExtend2" id="county_' +
//       flowId +
//       '"  style="width:100px;"></select></td></tr>' +
//       '<tr><td><span> </span>邮政编码：</td></tr><tr><td><input name="sPostCode" type="text" /></td></tr>' +
//       '<tr><td><span class="star">* </span>详细地址：</td></tr><tr><td><input name="sAddress" type="text" /></td></tr><tr><td>发货订单：<span id="sExtend1_' +
//       flowId +
//       '">暂无</span></td></tr>' +
//       '</tbody></table></section><footer><a href="###" id="personInfoContentBtn_' +
//       flowId +
//       '" class="submitBtn"></a></footer></form></div>'
//     //提交个人信息
//     window[amsCfg] = {
//       iActivityId: iActivityId, // AMS活动号
//       iFlowId: flowId, // 流程号
//       _everyRead: true,
//       success: function (res) {
//         //提交成功的回调
//         if (typeof res.jData == 'object') {
//           //返回已经提交的数据，填充页面
//           need(['biz.provincecityselector2', 'util.form'], function (pcs, FormManager) {
//             //显示弹出框
//             g('personInfoContent_' + flowId).style.display = 'block'

//             //关闭弹出框
//             g('colseLayer_' + flowId).onclick = function () {
//               g('personInfoContent_' + flowId).style.display = 'none'
//             }

//             //提交按钮事件
//             g('personInfoContentBtn_' + flowId).onclick = function () {
//               var fillData = FormManager.getAllInputValue('form_personInfo_' + flowId)
//               for (var i in fillData) {
//                 var _val = fillData[i]
//                 switch (i) {
//                   case 'sName': {
//                     if (!_val) {
//                       alert('姓名不能为空')
//                       return false
//                     }
//                     if (milo.getByteLength(_val) > 30) {
//                       alert('姓名长度不能超过30个字节。')
//                       return false
//                     }
//                     break
//                   }
//                   case 'sIdentity': {
//                     if (!_val) {
//                       alert('身份证号码不能为空')
//                       return false
//                     }
//                     if (!milo.isIDCard(_val)) {
//                       alert('身份证号码有误。')
//                       return false
//                     }
//                     break
//                   }
//                   case 'sMobile': {
//                     if (!_val) {
//                       alert('手机号码不能为空')
//                       return false
//                     }
//                     if (isNaN(_val) || _val.indexOf('.') >= 0) {
//                       alert('手机号码必须为数字。')
//                       return false
//                     }
//                     if (_val.length > 11) {
//                       alert('手机号码不得超过11位。')
//                       return false
//                     }
//                     break
//                   }
//                   case 'sAddress': {
//                     if (!_val) {
//                       alert('详细地址不能为空')
//                       return false
//                     }
//                     if (milo.getByteLength(_val) > 100) {
//                       alert('详细地址不能超过100个字节。')
//                       return false
//                     }
//                     break
//                   }
//                   default: {
//                   }
//                 }
//               }

//               window[amsCfg].sData = fillData
//               amsSubmit(iActivityId, flowId)
//             }
//             var pcsConfig = {
//               provinceId: 'province_' + flowId,
//               cityId: 'city_' + flowId,
//               areaId: 'county_' + flowId,
//               initVal: []
//             }
//             if (res.jData.sProvince && res.jData.sCity && res.jData.sExtend2) {
//               pcsConfig.initVal = [res.jData.sProvince, res.jData.sCity, res.jData.sExtend2]
//             }
//             pcs.show(pcsConfig)

//             //发货订单:
//             if (res.jData.sExtend1) {
//               g('sExtend1_' + flowId).innerHTML = res.jData.sExtend1
//             }
//             delete res.jData.sProvince
//             delete res.jData.sCity
//             FormManager.setAllInputValue(res.jData, 'form_personInfo_' + flowId)

//             if (typeof res.jData.arrPackageInfo != 'undefined' && res.jData.arrPackageInfo.length > 0) {
//               //如果存在实物信息，则显示
//               g('tr_package_name_' + flowId).style.display = ''
//               g('tr_package_value_' + flowId).style.display = ''
//               for (var i = 0; i < res.jData.arrPackageInfo.length; ++i) {
//                 var iPackageId = res.jData.arrPackageInfo[i].iPackageId
//                 var sPackageName = res.jData.arrPackageInfo[i].sPackageName
//                 g('package_' + flowId).options[i] = new Option(sPackageName, iPackageId + '|' + sPackageName)
//               }
//             }
//           })
//         } else {
//           need(['biz.widget.dialog'], function (Dialog) {
//             Dialog.alert(res.sMsg)
//           })
//         }
//       }
//     }

//     milo.ready(function () {
//       need(['biz.login'], function (LoginManager) {
//         //填写按钮的点击事件绑定
//         $(domStr).click(function () {
//           LoginManager.submitLogin(function () {
//             window[amsCfg].sData = {
//               iShow: 1
//             }
//             amsSubmit(iActivityId, flowId)
//           })
//         })
//       })
//     })
//     $('script:last').after(h5Template)
//   } else {
//     var pcTemplate =
//       '<style>.donsonClass{background: #fff !important; left: 40% !important ;width: 50%;font-size: 18px;height:700px !important; padding-left: 40px !important;padding-top: 40px !important;}</style>' +
//       '<div id="personInfoContent_' +
//       flowId +
//       '" class="defaultContent donsonClass" style="display:none;"><a href="javascirpt:;" id="colseLayer_' +
//       flowId +
//       '">关闭</a><p>个人信息填写:为保证实物奖励能准确邮寄，下面所有项目务必详细填写！<span>未获得实物奖励请勿填写</span></p>' +
//       '<form id="user_userInfoform_' +
//       flowId +
//       '" name="user_userInfoform_' +
//       flowId +
//       '">' +
//       '<table width="422" cellspacing="0" cellpadding="0" border="0"><tbody><tr style="display:none;" id="tr_package_' +
//       flowId +
//       '"><td><span>*</span> 所获实物：</td><td><select name="sPackageInfo" id="package_' +
//       flowId +
//       '"></select></td></tr><tr><td><span>*</span>' +
//       '姓名：</td><td><input name="sName" type="text"></td></tr>' +
//       // <tr><td><span>*</span> 性别：</td>
//       // <td>
//       // 					<label>男：<input style="width:14px;" name="sGender" value="male" type="radio" checked="checked"></label>
//       // 					<label>女：<input style="width:14px;" name="sGender" value="female" type="radio"></label>
//       // 				</td>
//       // 			</tr>
//       '<tr><td><span>*</span> 身份证号码：</td><td><input name="sIdentity" type="text"></td></tr>' +
//       '<tr><td><span>*</span> 手机号码：</td><td><input name="sMobile" type="text"></td></tr>' +
//       '<tr><td><span>*</span> 省份：</td><td><select name="sProvince" id="province_' +
//       flowId +
//       '" type="text"></select></tr>' +
//       '<tr><td><span>*</span> 城市：</td><td><select name="sCity" id="city_' +
//       flowId +
//       '" type="text"></select></tr>' +
//       '<tr><td><span>*</span> 区/县：</td><td><select name="sExtend2" id="county_' +
//       flowId +
//       '" type="text"></select></tr>' +
//       '<tr><td><span>*</span> 详细地址：</td><td><input name="sAddress" type="text"></td></tr>' +
//       '<tr><td><span>*</span> 邮编：</td><td><input name="sPostCode" type="text"></td></tr>' +
//       '<tr><td>发货订单：</td><td><span id="sExtend1_' +
//       flowId +
//       '">暂无</span></td></tr>' +
//       '<tr><td></td><td><a href="###" style="display:block;" id="personInfoContentBtn_' +
//       flowId +
//       '" class="submitBtn">提交订单</a></td></tr>' +
//       '</tbody></table></form></div>'
//     window[amsCfg] = {
//       iActivityId: iActivityId, // AMS活动号
//       iFlowId: flowId, // 流程号
//       _everyRead: true,
//       fFlowSubmitEnd: function (res) {
//         if (typeof res.jData == 'object') {
//           //返回已经提交的数据，填充页面
//           need(['biz.provincecityselector2', 'biz.dialog', 'util.form'], function (pcs, Dialog, FormManager) {
//             Dialog.show({
//               id: 'personInfoContent_' + flowId + ''
//             })

//             g('personInfoContentBtn_' + flowId + '').onclick = function () {
//               var fillData = FormManager.getAllInputValue('personInfoContent_' + flowId + '')
//               for (var i in fillData) {
//                 var _val = fillData[i]
//                 switch (i) {
//                   case 'sName': {
//                     if (!_val) {
//                       alert('姓名不能为空')
//                       return
//                     }
//                     if (milo.getByteLength(_val) > 30) {
//                       alert('姓名长度不能超过30个字节。')
//                       return
//                     }
//                     break
//                   }
//                   // case 'sGender':{
//                   //   if(!_val){alert("性别必须选择"); return;}
//                   //   break;
//                   // }
//                   case 'sIdentity': {
//                     if (!_val) {
//                       alert('身份证号码不能为空')
//                       return
//                     }
//                     if (!milo.isIDCard(_val)) {
//                       alert('身份证号码有误。')
//                       return
//                     }
//                     break
//                   }
//                   case 'sMobile': {
//                     if (!_val) {
//                       alert('手机号码不能为空')
//                       return
//                     }
//                     if (isNaN(_val) || _val.indexOf('.') >= 0) {
//                       alert('手机号码必须为数字。')
//                       return
//                     }
//                     if (_val.length > 11) {
//                       alert('手机号码不得超过11位。')
//                       return
//                     }
//                     break
//                   }
//                   case 'sAddress': {
//                     if (!_val) {
//                       alert('详细地址不能为空')
//                       return
//                     }
//                     if (milo.getByteLength(_val) > 100) {
//                       alert('详细地址不能超过100个字节。')
//                       return
//                     }
//                     break
//                   }
//                   case 'sPostCode': {
//                     if (!_val) {
//                       alert('邮政编码不能为空')
//                       return
//                     }
//                     if (milo.getByteLength(_val) > 8) {
//                       alert('邮政编码不能超过8个字节。')
//                       return
//                     }
//                     if (isNaN(_val) || _val.indexOf('.') >= 0) {
//                       alert('邮政编码必须为数字。')
//                       return
//                     }
//                     break
//                   }
//                   case 'sProvince': {
//                     if (!_val) {
//                       alert('请选择省份')
//                       return
//                     }
//                     break
//                   }
//                   case 'sCity': {
//                     if (!_val) {
//                       alert('请选择城市')
//                       return
//                     }
//                     break
//                   }
//                   case 'sExtend2': {
//                     if (!_val) {
//                       alert('请选择区/县')
//                       return
//                     }
//                     break
//                   }
//                   default: {
//                   }
//                 }
//               }
//               window[amsCfg].sData = fillData
//               amsSubmit(iActivityId, flowId)
//             }
//             g('colseLayer_' + flowId).onclick = function () {
//               Dialog.hide()
//             }

//             if (g('province_' + flowId).innerHTML != '') {
//               g('province_' + flowId).innerHTML = ''
//             }
//             if (g('city_' + flowId).innerHTML != '') {
//               g('city_' + flowId).innerHTML = ''
//             }
//             if (g('county_' + flowId).innerHTML != '') {
//               g('county_' + flowId).innerHTML = ''
//             }

//             var pcsConfig = {
//               provinceId: 'province_' + flowId,
//               cityId: 'city_' + flowId,
//               areaId: 'county_' + flowId,
//               initVal: []
//             }
//             if (res.jData.sProvince && res.jData.sCity && res.jData.sExtend2) {
//               pcsConfig.initVal = [res.jData.sProvince, res.jData.sCity, res.jData.sExtend2]
//             }
//             pcs.show(pcsConfig)
//             //发货订单:
//             if (res.jData.sExtend1) {
//               g('sExtend1_' + flowId).innerHTML = res.jData.sExtend1
//             }
//             delete res.jData.sProvince
//             delete res.jData.sCity
//             FormManager.setAllInputValue(res.jData, 'personInfoContent_' + flowId + '')

//             if (typeof res.jData.arrPackageInfo != 'undefined' && res.jData.arrPackageInfo.length > 0) {
//               document.getElementById('tr_package_' + flowId).style.display = ''
//               var package_id: any = document.getElementById('package_' + flowId)
//               for (var i = 0; i < res.jData.arrPackageInfo.length; ++i) {
//                 var iPackageId = res.jData.arrPackageInfo[i].iPackageId
//                 var sPackageName = res.jData.arrPackageInfo[i].sPackageName
//                 package_id.options[i] = new Option(sPackageName, iPackageId + '|' + sPackageName)
//               }
//             }
//           })
//         } else {
//           alert(res.sMsg)
//         }
//       }
//     }
//     milo.ready(function () {
//       $(domStr).click(function () {
//         LoginManager.submitLogin(function () {
//           window[amsCfg].sData = {
//             iShow: 1
//           }
//           amsSubmit(iActivityId, flowId)
//         })
//       })
//     })

//     $('script:last').after(pcTemplate)
//   }
// }
function support2Ams(): void {
  var amsCfg = 'amsCfg_839141'
  window[amsCfg] = {
    _everyRead: true, //_everyRead参数用于控制缓存，设为true表示每次发请求都会读取amsCfg参数的值，建议加上
    iActivityId: 449749, //活动id
    iFlowId: 839141, //流程id
    sNeedSubmitPopDiv: false,
    sData: {
      //自定义传参
    },
    fFlowSubmitEnd: function (res) {
      return
    },
    fFlowSubmitFailed: function (res) {
      //失败会走到这个函数
      setTimeout(function () {
        amsSubmit(449749, 839141)
      }, 10000)
    }
  }
  console.log('上报数据')
  amsSubmit(449749, 839141)
}
function btnGray(zigeNum, ele, grayClassName) {
  var maxCount = parseInt(ele.maxCount) || 1
  var className = ele.grayClass || ele.class
  if (parseInt(zigeNum) === maxCount) {
    $(className).addClass(grayClassName)
    $(className).text('已领取')
  }
}

function btnGrayNormalHandle(cfhdCallbackObj, btnClassList, grayClassName) {
  btnClassList &&
    btnClassList.forEach(function (ele) {
      if (cfhdCallbackObj[ele.key] && !ele.notNeedGray) {
        btnGray(cfhdCallbackObj[ele.key].split(',')[ele.postion], ele, grayClassName)
      }
    })
}

function request(url, method) {
  return new Promise((resolve, reject) => {
    // 获取 XMLHttpRequest 对象的实例
    const xhr = new XMLHttpRequest()
    xhr.overrideMimeType('text/html;charset=gb2312')
    xhr.open(method, url)
    xhr.send(null)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        /**
         * http 状态码在 200 的区间都是请求成功的状态
         * 状态码 304 表示缓存文件
         */
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
          // console.log(xhr)
          const template = xhr.responseText
          resolve(template)
        } else {
          console.log('request was unsuccessful:' + xhr.status)
          reject('fail')
        }
      }
    }
  })
}

function loadScript(url, charset = 'gbk') {
  return new Promise((resolve, reject) => {
    let _script = document.createElement('script')
    _script.setAttribute('charset', charset)
    _script.setAttribute('type', 'text/javascript')
    _script.setAttribute('src', url)
    document.getElementsByTagName('head')[0].appendChild(_script)

    var timeout = setTimeout(() => {
      reject('timeout') //rejected
    }, 5000)

    _script.onload = () => {
      //加载完成
      clearTimeout(timeout)
      resolve('') //fulfilled
    }
    _script.onerror = () => {
      //加载失败
      reject('fail') //rejected
    }
  })
}
function loadStyle(url) {
  return new Promise((resolve, reject) => {
    let _style = document.createElement('style')
    // _style.setAttribute('charset', 'utf-8')
    // rel="stylesheet"
    _style.setAttribute('rel', 'stylesheet')
    _style.setAttribute('href', url)
    document.getElementsByTagName('head')[0].appendChild(_style)

    var timeout = setTimeout(() => {
      reject('timeout') //rejected
    }, 5000)

    _style.onload = () => {
      //加载完成
      clearTimeout(timeout)
      resolve('') //fulfilled
    }
    _style.onerror = () => {
      //加载失败
      reject('pull fail') //rejected
    }
  })
}

function loadTab({ container, html, js, jsCharSet, css = '' }) {
  if ((window as any).powerByMicroPageTab1) {
    console.log('已经加载过啦~')
  } else {
    ;(window as any).powerByMicroPageTab1 = true
    request(html, 'get').then((tpl: any) => {
      $(container).empty()
      $(container).append(tpl)
      // console.log(tpl)
      loadScript(js, jsCharSet)
      if (css) {
        loadStyle(css)
      }
    })
  }
}
function TGDialogS(id) {
  if ($('#' + id).length <= 0) {
    console.log(`弹窗id有误${id}`)
    return
  }
  // 隐藏上一次的弹窗
  $('.tgdia-class').hide()
  var $dom = $('#' + id).show()
  // 获取缩放前的宽高
  var h = $dom[0].offsetHeight / 2
  var w = $dom[0].offsetWidth / 2
  // 需要pop的元素加上style
  $dom.attr('style', `position:fixed;left:50%;top:50%; margin-top:${-h}px;margin-left: ${-w}px;z-index:1002;display:block;`)
  // 增加标识
  $dom.addClass('tgdia-class')
  // 蒙版弹窗
  var template = `<div class="tgdialog-main" onclick="closeDialog()" style="width: 100%;height:${$('body').css('height')};background: rgba(0,0,0,0.5);position: absolute;top: 0px;left:0;z-index:1001"></div>`
  // <div class="tgdialog-content" style="position:fixed;left:50%;top:${$(window).height()/2}px; transform: translate(${-w}px, ${-h}px);z-index:1002">${t}</div>
  //蒙版贴上去并且打开
  $('.tgdialog-main').show()
  $('body').append(template)
}
function closeDialog() {
  // 删除蒙版，隐藏所有弹窗
  $('.tgdialog-main').remove()
  $('.tgdia-class').hide()
}
// 工具函数暴露到全局中
;(window as any).TGDialogS = TGDialogS
;(window as any).closeDialog = closeDialog

export { getUrlParam, copyText, zalert, support2Ams, btnGrayNormalHandle, loadTab, isWX, sth, isQQ, TGDialogS, initShareFunc }
